import React from "react";

import GreyTable from '../../../../components/Tables/GreyTable'
import { Col, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import Cookies from "js-cookie";
import { Loader } from '../../../../components/Loader/Loader';
import { useTheme } from '../../../../Themecontext/Themecontext';

export const Inward365 = ({ Muldata }) => {


  const { InwParty365Data, AccountToPGroupListData } = useSelector((state) => state.PartyProfileSlice);

  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;


  const columns = [
    // { Header: "Chart", accessor: "chartButton", width: "60px" },
    { key: "srNumber", label: "Sr. No.", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "Month", label: "Month Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "InwMeter", label: "Inward Meter", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "1", label: "1", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "2", label: "2", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "3", label: "3", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "4", label: "4", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "5", label: "5", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "6", label: "6", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "7", label: "7", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "8", label: "8", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "9", label: "9", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "10", label: "10", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "11", label: "11", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "12", label: "12", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "13", label: "13", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "14", label: "14", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "15", label: "15", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "16", label: "16", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "17", label: "17", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "18", label: "18", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "19", label: "19", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "20", label: "20", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "21", label: "21", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "22", label: "22", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "23", label: "23", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "24", label: "24", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "25", label: "25", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "26", label: "26", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "27", label: "27", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "28", label: "28", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "29", label: "29", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "30", label: "30", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "31", label: "31", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
  ];

  const Date = [
    "InwMeter",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
  ];

  const formattedRows = InwParty365Data?.Inw365?.map((row, index, arr) => {
    const totalLength = arr.length.toString().length;
    const formattedRow = {
      // srNumber: (index + 1).toString().padStart(totalLength, "0"),
      id: index,
      ...row,
    };

    if (formattedRow.Month) {
      formattedRow.Month = formattedRow.Month.split("'")[0];
    }

    Date.forEach((field) => {
      formattedRow[field] = row[field];
    });

    return formattedRow;
  });

  if (InwParty365Data === null) {

    return (
      <div className="flex justify-center items-center h-screen text-xl text-green-700">
        <Loader />
      </div>
    );
  }



  return (
    <>
      <div>
        <Row>
          <Col>
            <>
              <>
                <div
                  style={{
                    borderRadius: "12px",
                    overflow: "hidden",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                  }}
                >
                  <div
                    style={{
                      backgroundColor:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour1,
                      color:
                        isdark === "light"
                          ? iscolour?.Colour5
                          : iscolourDark?.Colour8,
                      padding: "14px",
                    }}
                  >
                    <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px",fontWeight:"700" }}>
                      MERGING
                    </h2>
                  </div>

                  {InwParty365Data?.Inw365 && InwParty365Data?.Inw365?.length > 0 ? (
                    <GreyTable columns={columns} data={formattedRows} iscolourDark={iscolourDark}
                      iscolour={iscolour} />
                  ) : (
                    <p
                      style={{
                        color: "#ff0000",
                        fontWeight: "bold",
                        padding: "10px",
                      }}
                    >
                      Data Not Found
                    </p>
                  )}
                </div>
              </>

              {Muldata?.map((el) => {
                const formattedRows1 = el?.Inw365?.map((row, index, arr) => {
                  const totalLength = arr.length.toString().length;

                  const formattedRow = {
                    srNumber: (index + 1).toString().padStart(totalLength, "0"),
                    id: index,
                    ...row,
                  };

                  if (formattedRow.Month) {
                    formattedRow.Month = formattedRow.Month.split("'")[0];
                  }

                  Date.forEach((field) => {
                    formattedRow[field] = row[field];
                  });

                  return formattedRow;
                });
                return (
                  <>

                    <div
                      style={{
                        borderRadius: "12px",
                        overflow: "hidden",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                        marginTop: "20px"
                      }}
                    >
                      <div
                        style={{
                          backgroundColor:
                            isdark === "light"
                              ? iscolour?.Colour1
                              : iscolourDark?.Colour1,
                          color:
                            isdark === "light"
                              ? iscolour?.Colour5
                              : iscolourDark?.Colour8,
                          padding: "14px",
                        }}
                      >
                        <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px" ,fontWeight:"700" }}>
                          {AccountToPGroupListData?.Data?.find(
                            (nel) => Number(el.group) === Number(nel.ProductionGroupMstID)
                          )?.ProductionGroupMstName || `Group ${el.group}`}
                        </h2>
                      </div>

                      {el?.Inw365 && el?.Inw365?.length > 0 ? (
                        <GreyTable columns={columns} data={formattedRows1} iscolourDark={iscolourDark}
                          iscolour={iscolour} />
                      ) : (
                        <p
                          style={{
                            color: "#ff0000",
                            fontWeight: "bold",
                            padding: "10px",
                          }}
                        >
                          Data Not Found
                        </p>
                      )}
                    </div>
                  </>
                );
              })}
            </>
          </Col>
        </Row>
      </div>
    </>
  )
}


